module.exports = __webpack_public_path__ + "static/media/Airco.51375baf.mp3";